import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import {environment} from "../../environments/environment";
import {getapiUrlInterceptVer} from "../common/common";
// import * as Rx from 'rxjs/Rx';


@Injectable()
export class WebsocketService {

  // // private socket = io('http://localhost:3000');
  // private socket = io(environment.apiUrlInterceptVer);
  // constructor() { }
  //
  // gAuthJoin(data) {
  //   // console.log(data);
  //   this.socket.emit('gAuthJoin', data);
  // }
  //
  // gAuthClose(data) {
  //   // console.log(data);
  //   this.socket.emit('gAuthClose', data);
  // }
  //
  // gAuthReceived(aid: string) {
  //   const observable = new Observable<any>(observer => {
  //     this.socket.on(aid, (data) => {
  //       observer.next(data);
  //     });
  //     return () => {
  //       this.socket.disconnect();
  //     };
  //   });
  //   return observable;
  // }

  private socket;
  constructor() {
    if (!environment.OauthCK) {
      this.socket = io(getapiUrlInterceptVer());
    }
  }

  gAuthJoin(data) {
    //console.log("io.gAuthJoin");
    this.socket.emit("gAuthJoin", data);
  }

  gAuthClose(data) {
    const self = this;
    this.socket.emit("gAuthClose", data);
  }

  gAuthReceived(aid: string) {
    //console.log("io.gAuthJoinR");
    const observable = new Observable<any>(observer => {
      this.socket.on(aid, data => {
        // console.log("io.gAuthJoinD", data);
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
    return observable;
  }
}
